import * as ActionTypes from 'state/actions/types'

const initialState = {
  environments: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SELECT_AGENT: {
      return {
        ...state,
        environments: []
      }
    }

    case ActionTypes.ACTIVATE_ORGANISATION: {
      return state
    }

    case ActionTypes.PROJECT_INFO_REQUEST_SUCCESS: {

      return {
        ...state,
        environments: action?.response?.payload?.environments || []
      }
    }

    default:
      return state
  }
}
